import Konva from 'konva/konva'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { timeToX } from '../utils'

const moment = extendMoment(Moment)

const separator = { color: 'rgba(0,0,0,0.54)', width: 1 }

export default class DaySeparatorsLayer extends Konva.Layer {
  constructor ({ name }) {
    super({ name })
  }

  init ({ timeFrom, timeTo, yFrom, yTo, width }) {
    Object.assign(this, { timeFrom, timeTo, yFrom, yTo, width })

    this._render()
  }

  _render () {
    this.destroyChildren()

    const { timeFrom, timeTo, yFrom, yTo, width } = this

    const range = moment.range(timeFrom, timeTo).snapTo('days')
    const midnights = Array.from(range.by('days'))
      .filter((_, index) => index !== 0) // skip first
      .map(m => m.valueOf()) // convert moment to Unix milliseconds
    const lines = midnights
      .map(time => timeToX({ timeFrom, timeTo, width, time }))
      .map(x => new Konva.Line({
        points: [x, yFrom, x, yTo],
        stroke: separator.color,
        strokeWidth: separator.width
      }))

    lines.forEach(line => this.add(line))

    this.draw()
  }
}
